import { NoteLoader } from './NoteLoader'

export default NoteLoader
